
import moment from 'moment';
import {
  Component, Mixins, Watch,
} from 'vue-property-decorator';
import DatePickerDialog from '@/components/DatePickerDialog.vue';
import AttachmentWithStatus from '@/components/AttachmentWithStatus.vue';
import CheckZonaVincolo from '@/components/CheckZonaVincolo.vue';
import EditCheckZonaVincoloDialog from '@/components/EditCheckZonaVincoloDialog.vue';
import {
  getLeadCustomValueText, getLeadCustomValueDate,
} from '@/helpers';
import { AttachmentType, BoxStatusType, Lead } from '@/types';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import CurrentSupply from '@/components/CurrentSupply.vue';
import AttachmentsList from '@/components/AttachmentsList.vue';
import EditConnectionDialogMixin from '@/mixins/EditConnectionDialogMixin.vue';

moment.locale('it');

@Component({
  components: {
    DatePickerDialog,
    CurrentSupply,
    AttachmentsList,
    AttachmentWithStatus,
    CheckZonaVincolo,
    EditCheckZonaVincoloDialog,
  },
})
// eslint-disable-next-line max-len
export default class EditConnectionAuthDialog extends Mixins(EditConnectionDialogMixin, UtilsMixin) {
  editCheckZonaVincolo = false

  // Il form è valido?
  isFormValid = false

  titoloAutorizzativo: BoxStatusType = 'todo'
  titoloAutorizzativoDate: Date | null = null;
  titoloAutorizzativoDoneDate: Date | null = null;

  titoloAutorizzativoNotes: string | null | undefined = null

  checkZonaVincolo: BoxStatusType = 'todo'
  checkZonaVincoloLastUpdate: Date | null = null
  checkZonaVincoloUpdater: string | null | undefined = null
  checkZonaVincoloNotes: string | null | undefined = null
  autodichiarazioneCliente: BoxStatusType = 'todo'
  autodichiarazioneClienteNotes: string | null | undefined = null

  // Aggiorna i campi con gli eventuali nuovi valori della Connection/Lead selezionata
  refresh() {
    console.log(`${this.constructor.name}: refresh()`); // eslint-disable-line no-console

    // Svuota i dati nell'attesa che sia caricata la figlia elettrica
    this.titoloAutorizzativoDate = null;

    this.checkZonaVincolo = (getLeadCustomValueText(this.lead, 'checkZonaVincolo') ?? 'todo') as BoxStatusType;
    this.checkZonaVincoloLastUpdate = getLeadCustomValueDate(this.lead, 'checkZonaVincoloLastUpdate');
    this.checkZonaVincoloUpdater = getLeadCustomValueText(this.lead, 'checkZonaVincoloUpdater');
    this.checkZonaVincoloNotes = getLeadCustomValueText(this.lead, 'checkZonaVincoloNotes');
    this.autodichiarazioneCliente = (getLeadCustomValueText(this.lead, 'autodichiarazioneCliente') ?? 'todo') as BoxStatusType;
    this.autodichiarazioneClienteNotes = getLeadCustomValueText(this.lead, 'autodichiarazioneClienteNotes');

    // Richiama il metodo del mixin
    return this.mixinRefresh();
  }

  updateAttachmentStatus(type: AttachmentType, status: BoxStatusType) {
    console.log(`${this.constructor.name}: updateAttachmentStatus(${type}, ${status})`); // eslint-disable-line no-console

    // Se lo stato non è uno di quelli gestiti, si ferma subito
    if (type in this === false) { return; }

    (this[type] as BoxStatusType) = status;

    const update = {} as { [key: string]: unknown };

    update[type] = status;

    this.$store.dispatch('updateConnectionFields', {
      fields: update,
    });
  }

  onClickDate(name: string) {
    console.log(`${this.constructor.name}: onClickDate(${name})`); // eslint-disable-line no-console

    // Imposta per quale campo verrà utilizzato il DatePicker
    this.datePickerName = name;

    // Imposta l'eventuale data precedentemente selezionata
    this.datePickerDate = this[name]
      ? moment(this[name]).toISOString(true).substring(0, 10)
      : null;

    // Apre il dialog per la selezione della data
    this.datePickerDialog = true;
  }

  @Watch('currentElettricaFiglia')
  onCurrentElettricaFigliaChange(val: Lead | null, oldVal: Lead | null) {
    if (oldVal === null && val !== null) {
      this.titoloAutorizzativoDate = this.currentElettricaFiglia?.titoloAutorizzativoDate ?? null;

      this.titoloAutorizzativo = (this.currentElettricaFiglia?.titoloAutorizzativo ?? 'todo') as BoxStatusType;
      this.titoloAutorizzativoNotes = getLeadCustomValueText(this.currentElettricaFiglia, 'titoloAutorizzativoNotes');
    }
  }

  onCheckZonaVincoloUpdate(update: { [key: string]: unknown }) {
    console.log(`${this.constructor.name}: onCheckZonaVincoloUpdate() update =`, update); // eslint-disable-line no-console

    // checkZonaVincolo, checkZonaVincoloLastUpdate, checkZonaVincoloUpdater
    if ('checkZonaVincolo' in update && update.checkZonaVincolo !== this.checkZonaVincolo) {
      this.checkZonaVincolo = update.checkZonaVincolo as BoxStatusType;
      this.checkZonaVincoloLastUpdate = new Date();
      this.checkZonaVincoloUpdater = this.$store.getters.currentUser?.name ?? null;

      this.$store.dispatch('updateConnectionFields', {
        fields: {
          checkZonaVincolo: this.checkZonaVincolo,
          checkZonaVincoloLastUpdate: this.checkZonaVincoloLastUpdate,
          checkZonaVincoloUpdater: this.checkZonaVincoloUpdater,
        },
      });
    }
    // checkZonaVincoloNotes
    if ('checkZonaVincoloNotes' in update && update.checkZonaVincoloNotes !== this.checkZonaVincoloNotes) {
      this.checkZonaVincoloNotes = update.checkZonaVincoloNotes as string;
      this.$store.dispatch('updateConnectionFields', {
        fields: {
          checkZonaVincoloNotes: this.checkZonaVincoloNotes,
        },
      });
    }
    // autodichiarazioneCliente
    if ('autodichiarazioneCliente' in update && update.autodichiarazioneCliente !== this.autodichiarazioneCliente) {
      this.autodichiarazioneCliente = update.autodichiarazioneCliente as BoxStatusType;
      this.$store.dispatch('updateConnectionFields', {
        fields: {
          autodichiarazioneCliente: this.autodichiarazioneCliente,
        },
      });
    }
    // autodichiarazioneClienteNotes
    if ('autodichiarazioneClienteNotes' in update && update.autodichiarazioneClienteNotes !== this.autodichiarazioneClienteNotes) {
      this.autodichiarazioneClienteNotes = update.autodichiarazioneClienteNotes as string;
      this.$store.dispatch('updateConnectionFields', {
        fields: {
          autodichiarazioneClienteNotes: this.autodichiarazioneClienteNotes,
        },
      });
    }
  }
}
